export const volumes = [
  {
    number: 1,
    title: 'DENTAL PREDICTABILITY ROADMAP™',
    subtitle: 'The Clinical Pathway for Identifying High-Risk Tooth Movements',
    intro: 'Start by understanding which planned movements deserve closer evaluation.',
    bullets: [
      'Factors that influence clear aligner movement predictability.',
      'Movement-specific clinical risk considerations.',
      'Anatomical and biomechanical limitations.',
      'Structured pre-treatment evaluation pathways.',
      'Risk assessment frameworks for complex movements.',
      'Visual clinical decision maps.',
    ],
    outcome: 'A more systematic approach to identifying movement-related risks before treatment begins.',
  },
  {
    number: 2,
    title: 'ALIGNER TREATMENT PLANNING BLUEPRINT™',
    subtitle: 'The Step-by-Step Framework for Reviewing Digital Treatment Plans',
    intro: 'A digital simulation is a planning tool—not a guarantee of biological movement. This volume helps you evaluate treatment setups more critically.',
    bullets: [
      'Pre-treatment diagnostic considerations.',
      'Digital setup evaluation frameworks.',
      'Treatment objective prioritization.',
      'Movement sequencing principles.',
      'Space management considerations.',
      'Clinical planning checkpoints.',
    ],
    outcome: 'A clearer process for reviewing treatment plans before approving them.',
  },
  {
    number: 3,
    title: 'TOOTH MOVEMENT PREDICTABILITY ATLAS™',
    subtitle: 'The Visual Guide to Complex Clear Aligner Movements',
    intro: 'Understand the clinical considerations behind movements that can be challenging to express.',
    bullets: [
      'Rotational movement considerations.',
      'Extrusion and intrusion biomechanics.',
      'Torque expression and root control.',
      'Tipping versus bodily movement.',
      'Movement-specific limitations.',
      'Visual comparisons and clinical illustrations.',
    ],
    outcome: 'A practical visual reference for evaluating different tooth movements.',
  },
  {
    number: 4,
    title: 'BIOMECHANICAL CONTROL BLUEPRINT™',
    subtitle: 'The Clinical Framework for Evaluating Attachments, Forces, and Auxiliary Mechanics',
    intro: 'Not every movement requires the same biomechanical strategy. This volume helps you understand the factors involved in evaluating movement-control approaches.',
    bullets: [
      'Attachment function and selection considerations.',
      'Force systems in clear aligner therapy.',
      'Anchorage and movement-control principles.',
      'Auxiliary mechanics and their clinical indications.',
      'Interproximal reduction planning considerations.',
      'Biomechanical decision frameworks.',
    ],
    outcome: 'A more structured understanding of the mechanics behind planned movements.',
  },
  {
    number: 5,
    title: 'CLINICAL DECISION PATHWAYS™',
    subtitle: 'The Visual Decision Guide for Complex Aligner Planning Situations',
    intro: 'When multiple clinical variables interact, decision-making becomes more challenging. This volume organizes important planning considerations into practical pathways.',
    bullets: [
      'Movement-specific assessment pathways.',
      'Clinical risk-factor matrices.',
      'Alternative planning considerations.',
      'Setup review decision trees.',
      'Complex movement evaluation frameworks.',
      'Clinical documentation checkpoints.',
    ],
    outcome: 'A more organized approach to evaluating difficult planning decisions.',
  },
  {
    number: 6,
    title: 'ALIGNER SUCCESS ROADMAP™',
    subtitle: 'The Clinical Pathway for Monitoring Movement Expression and Treatment Progress',
    intro: 'Planning is only the beginning. This volume focuses on evaluating how planned movements translate into clinical progress.',
    bullets: [
      'Clinical tracking assessment principles.',
      'Movement-expression monitoring.',
      'Early discrepancy recognition.',
      'Follow-up evaluation checkpoints.',
      'Treatment progress documentation.',
      'Criteria for reassessment and planning review.',
    ],
    outcome: 'A structured reference for monitoring treatment progress and recognizing when further evaluation is needed.',
  },
];
